export default __webpack_public_path__ + "static/media/ecommerce.af6c04ed.svg";